import { defineStore } from 'pinia'

export const useGoCardlessStore = defineStore('goCardless', {
  state: () => (    
{
        "redirectFlowId": "",
        "sessionToken": "",
    }),
    persist: true,
  actions: {
    setGoCardless(goCardless) {
      Object.assign(this, goCardless)
    }
  },
})